module.exports = __webpack_public_path__ + "static/media/MHRM09N1035.850949ab.svg";